import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { CommunityIcon } from 'global/components/PerformIcons';

export default function PerformRealmCommunity(props) {
  const community = props.realm;

  return (
    <ListItem button style={{ marginLeft: 64 }}>
      <ListItemIcon>
        <CommunityIcon />
      </ListItemIcon>
      <ListItemText primary={community.name} />
    </ListItem>
  );
}

PerformRealmCommunity.defaultProps = {
  realm: {},
  currentRealm: 0,
};

PerformRealmCommunity.propTypes = {
  realm: PropTypes.object,
  currentRealm: PropTypes.number,
};
